<lib-page-layout>
  <lib-title-navbar pageHeader title="Napisz do nas"></lib-title-navbar>

  <div class="or-mx-16-px or-mt-16-px">
    <div
      #citiesBanner
      (click)="toggleCitiesTooltip()"
      class="contact__banner border-radius-4 or-p-12-px or-cursor-pointer">
      <div class="or-head-xs">Zostań Organizatorem gierek w aplikacji</div>
      <div class="or-note-sm or-mt-2-px">Napisz do nas i dołącz do grona Hostów!</div>

      <div class="contact__chips or-d-flex or-mt-8-px">
        @for (city of visibleCities; track city) {
          <div class="contact__chip">{{ city }}</div>
        }
        @if (hiddenCities.length) {
          <div class="contact__chip">+{{ hiddenCities.length }}</div>
        }
      </div>

      @if (showCitiesTooltip()) {
        <div class="contact__tooltip or-note-sm">
          <div class="or-head-xs or-mb-4-px">Gramy również w:</div>
          {{ hiddenCities.join(', ') }}
        </div>
      }
    </div>

    <div class="or-mt-24-px">
      @for (category of categories; track category.title) {
        <div class="or-d-flex or-align-items-center or-mb-12-px">
          <or-icon [name]="category.icon" size="m" circle class="or-mr-12-px" />
          <div>
            <div class="or-head-xs">{{ category.title }}</div>
            <div class="or-note-sm or-color-secondary-2 or-mt-2-px">{{ category.subtitle }}</div>
          </div>
        </div>
      }
    </div>

    <form [formGroup]="contactForm" class="or-mt-24-px">
      <div class="or-head-xs or-color-secondary-2 or-mb-4-px">Temat rozmowy</div>
      <div
        (click)="openTopicPicker()"
        class="contact__select input-style or-d-flex or-align-items-center or-justify-content-between or-cursor-pointer">
        <div [ngClass]="selectedTopic() ? '' : 'or-color-secondary-5'">{{ selectedTopic() ?? 'Wybierz temat...' }}</div>
        <img src="assets/icons/dropdown-icon.svg" class="or-ml-8-px" />
      </div>

      <div class="or-head-xs or-color-secondary-2 or-mb-4-px or-mt-16-px">Wiadomość</div>
      <ion-textarea
        formControlName="message"
        class="textarea-style outline-none"
        [placeholder]="'Opisz, w jakiej sprawie piszesz... (min. ' + minLength + ' znaków)'"
        maxlength="500"
        rows="5"
        auto-grow="true"></ion-textarea>

      @if (minLengthErrorVisible() && contactForm.get('message')?.invalid) {
        <div class="or-text-sm or-color-red or-mt-4-px">Minimalna ilość znaków to 10</div>
      }
    </form>

    <button
      (click)="sendMessage()"
      class="button-primary-style or-color-white or-h-48-px or-head-xs or-w-100-pc or-mt-16-px"
      [ngClass]="{ 'disabled-button': !contactForm.valid }">
      Wyślij
    </button>

    <div class="or-head-xs or-mt-32-px">Najczęściej zadawane pytania</div>
  </div>

  <lib-faq-list></lib-faq-list>
</lib-page-layout>
